<template>
    <div class="container-fluid">
        <slot :data="slotData"></slot>
    </div>
</template>

<script>
    import Mixins from './../common/AssessmentMixins'

    export default {
        mounted() {
            this.currentPage = this.initPage - 1;
            if (this.currentPage) {
                this.getQuestionPage()
            }
            this.getCounterData();
            this.contentPage = this.initialPageContent;
            prolitEvents.$on('Navigation:next', ev => this.nextPage());
            prolitEvents.$on('Navigation:previous', ev => this.previousPage());
            prolitEvents.$on('Navigation:finish', ev => this.finish());
            prolitEvents.$on('AnswerSelected', ev => {
                this.answer = ev;
            });
            this.setUrlPageParameter(this.currentPage + 1);
        },
        mixins: [Mixins],
        props: {
            initialPageContent: {
                default() {
                    return {
                        title: "",
                        body: ""
                    }
                }
            }
        },
        data() {
            return {
                currentPage: 0,
                question: {},
                answer: 0,
                contentPage: {
                    title: '',
                    body: ''
                },
                loading: false,
                updating: false,
            }
        },
        computed: {
            slotData() {
                return {
                    loading: this.loading,
                    currentPage: this.currentPage,
                    contentPage: {
                        title: this.contentPage.title,
                        body: !this.currentPage ? this.contentPage.body : "",
                    },
                    question: this.question,
                    answer: this.answer,
                    currentAnswered: this.currentAnswered,
                    totalAssessmentQuestions: this.totalAssessmentQuestions,
                    questionBody: this.questionBody,
                    nextPage: this.answer !== null,
                }
            },
            questionBody() {
                if (this.question.label === undefined) {
                    return null
                }

                if (this.question.label === null) {
                    return '<img src="' + this.question.assets[0] + '" />'
                }

                if (!!this.question.assets.length) {
                    let body = this.question.label;
                    for (let asset of this.question.assets) {
                        body = body.replace("%%asset_placeholder%%",'<img src="' + asset + '" />');
                    }
                    return body;
                }

                return this.question.label
            },
            routes() {
                if (this.assessment.slug === 'literacy') {
                    return {
                        questions: window.App.routes.api.literacy_questions.replace('NUM', 'page=' + this.currentPage),
                        store: window.App.routes.api.literacy_answer_store,
                        update: window.App.routes.api.literacy_answer_update,
                        assessments: window.App.routes.web.assessment,
                        counter: window.App.routes.api.assessments_count.replace("SLUG", this.assessment.slug),
                        finish: window.App.routes.api.assessments_finish.replace("SLUG", this.assessment.slug),
                    }
                }
                return {
                    questions: window.App.routes.api.numeracy_questions.replace('NUM', 'page=' + this.currentPage),
                    store: window.App.routes.api.numeracy_answer_store,
                    update: window.App.routes.api.numeracy_answer_update,
                    assessments: window.App.routes.web.my_profile,
                    counter: window.App.routes.api.assessments_count.replace("SLUG", this.assessment.slug),
                    finish: window.App.routes.api.assessments_finish.replace("SLUG", this.assessment.slug),

                }
            }
        },
        methods: {
            nextPage() {
                if (this.verifyQuestionIsAnswered() || !this.currentPage) {
                    this.currentPage
                        ? this.updating ? this.updateQuestion() : this.saveQuestion()
                        : null;

                    this.currentPage++;
                    this.setUrlPageParameter(this.currentPage + 1);
                    this.answer = 0;
                    this.getQuestionPage();
                }
            },
            verifyQuestionIsAnswered() {
                if (this.answer) {
                    return true;
                }
                prolitEvents.$emit('ShowNotAnswered');
                return false;
            },
            saveQuestion(finish) {
                this.loading=true;
                if (!this.currentPage) {
                    return;
                }
                axios.post(this.routes.store, {
                    question: this.question.code,
                    answer: this.answer,
                    last_page: this.currentPage+1
                }).then(response => {
                    !this.updating ? this.currentAnswered++ : null;
                    this.upadating = false;
                    if (finish) {
                        axios.post(this.routes.finish).then(response => {
                            window.location = this.routes.assessments;
                        }).catch(e => console.log(e));
                    } else {
                        this.loading = false;
                        this.setNextPage();
                    }
                }).catch(e => console.log(e));
            },
            updateQuestion() {
                if (!this.curren) {
                    return
                }
                ;
                this.loading = true;
                axios.put(this.routes.update, {
                    question: this.question.code,
                    answer: this.answer
                }).then(response => {
                    this.loading = false
                    this.upadating = false;
                    this.setNextPage();
                }).catch(e => console.log(e));
            },
            getQuestionPage() {
                this.loading = true
                axios.get(this.routes.questions).then(response => {
                    this.question = response.data.data[0];
                    this.answer = this.question.user_answer !== null ? this.question.user_answer : null;
                    this.updating = this.question.user_answer !== null;
                    this.loading = false;
                }).catch(e => console.log(e));
            },
            previousPage() {
                this.currentPage--;
                this.setUrlPageParameter(this.currentPage + 1);
                this.answer = 0;
                if (this.currentPage) {
                    this.getQuestionPage()
                }
            },
            finish() {
                if (this.verifyQuestionIsAnswered()) {
                    this.saveQuestion(true);
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/numeracyLiteracy/LiteracyNumeracyPage.vue